import { FC } from 'react';
import colors from '@styles/colors.module.scss';
import { Filter } from '@components/Filter';
import { Field } from '@components/Filter/types';

interface Props {
  onChange: (values: ResponsesFilterFormValues) => void;
}

export interface ResponsesFilterFormValues {
  name?: string;
  userName?: string;
}

export const ResponsesFilter: FC<Props> = ({ onChange }) => {
  const trackedFields: Field[] = [
    {
      type: 'text',
      name: 'name',
      props: {
        placeholder: 'Название вакансии',
        sx: { width: '280px', background: colors.white },
      },
    },
    {
      type: 'text',
      name: 'userName',
      props: {
        placeholder: 'Студент',
        sx: { width: '280px', background: colors.white },
      },
    },
  ];

  return <Filter onChange={onChange} clearable trackedFields={trackedFields} filter={['name', 'userName']} />;
};
